import React, {FC} from 'react';

import {renderIntegrationTypeCategoryName} from '../../../../../helpers/integrationTypesHelpers';
import {IntegrationTypeCategoriesEnum} from '../../../../../models/api/integrationTypesModel';
import {FrameCardCategory} from './frameCardCategory';

/*
 * Props.
 */

interface IntegrationFrameCardCategoryProps {
  category: IntegrationTypeCategoriesEnum;
}

/*
 * Component.
 */

export const IntegrationFrameCardCategory: FC<IntegrationFrameCardCategoryProps> = ({category}) => (
  <FrameCardCategory>{renderIntegrationTypeCategoryName(category)}</FrameCardCategory>
);
